module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei2.svg";